export default __webpack_public_path__ + "static/media/python.c828af7d.png";